// JsFromRoutes CacheKey 0a2d92a52a4287ce4b0caafc3aa6b0bf
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  ichraNotice: /* #__PURE__ */ definePathHelper('get', '/brokers/members/:member_id/ichra_notice'),
  transactions: /* #__PURE__ */ definePathHelper('get', '/brokers/members/:member_id/transactions'),
  index: /* #__PURE__ */ definePathHelper('get', '/brokers/members'),
  show: /* #__PURE__ */ definePathHelper('get', '/brokers/members/:id'),
}
